export class Filters_GetAvailability
{
    public bmUs: string[] = [];
    public availabilityTypes: string[] = [];
    public outageActiveOn: Date | null = null;
}